import React, { useEffect, useState } from 'react';
const PURCHASES = [{
  name: 'María L.',
  province: 'Buenos Aires'
}, {
  name: 'Carolina S.',
  province: 'Córdoba'
}, {
  name: 'Valentina R.',
  province: 'Santa Fe'
}, {
  name: 'Luciana M.',
  province: 'Mendoza'
}, {
  name: 'Florencia G.',
  province: 'Tucumán'
}, {
  name: 'Romina P.',
  province: 'Entre Ríos'
}, {
  name: 'Agustina D.',
  province: 'Salta'
}, {
  name: 'Camila T.',
  province: 'Neuquén'
}, {
  name: 'Daniela F.',
  province: 'Misiones'
}, {
  name: 'Sofía B.',
  province: 'Chaco'
}, {
  name: 'Paula V.',
  province: 'San Juan'
}, {
  name: 'Andrea K.',
  province: 'Río Negro'
}, {
  name: 'Julieta H.',
  province: 'Corrientes'
}, {
  name: 'Natalia C.',
  province: 'Jujuy'
}, {
  name: 'Gabriela R.',
  province: 'La Pampa'
}];
function getRandomMinutes() {
  return Math.floor(Math.random() * 25) + 3;
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [minutes, setMinutes] = useState(getRandomMinutes());
  useEffect(() => {
    // Show first popup after 8 seconds
    const initialDelay = setTimeout(() => {
      setVisible(true);
    }, 8000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Hide after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      // Show next one after 12-20 seconds
      const nextDelay = Math.floor(Math.random() * 8000) + 12000;
      const showTimer = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % PURCHASES.length);
        setMinutes(getRandomMinutes());
        setVisible(true);
      }, nextDelay);
      return () => clearTimeout(showTimer);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  const purchase = PURCHASES[currentIndex];
  return <div className={`fixed bottom-28 md:bottom-4 left-4 z-[50] max-w-[250px] sm:max-w-xs transition-all duration-500 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-428">
      <div className="bg-white border border-[#e8d5f0] rounded-xl p-3.5 shadow-[0_10px_30px_rgba(61,42,95,0.15)] backdrop-blur-sm" data-id="element-429">
        <div className="flex items-start gap-3" data-id="element-430">
          <div className="w-9 h-9 rounded-full bg-[#f3e9f7] border border-[#e8d5f0] flex items-center justify-center flex-shrink-0" data-id="element-431">
            <span className="text-sm" data-id="element-432">✨</span>
          </div>
          <div className="min-w-0" data-id="element-433">
            <p className="text-[#3d2a5f] text-sm font-semibold leading-tight" data-id="element-434">
              {purchase.name}
              <span className="text-[#6b5a85] font-normal" data-id="element-435"> de </span>
              <span className="text-[#c9a14d]" data-id="element-436">{purchase.province}</span>
            </p>
            <p className="text-[#6b5a85] text-xs mt-0.5" data-id="element-437">
              adquirió{' '}
              <span className="text-[#3d2a5f] font-medium" data-id="element-438">
                MegaPack Maestría Reiki
              </span>
            </p>
            <p className="text-[#6b5a85]/70 text-[10px] mt-1" data-id="element-439">
              hace {minutes} minutos
            </p>
          </div>
        </div>
      </div>
    </div>;
}